
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import PcSideChatPanel from '@/components/chat/PcSideChatPanel.vue';

@Component({
  components: { PcSideChatPanel },
})
export default class PcSideChatsBanner extends Vue {
  @Prop({ default: false }) private open!: boolean;
}
